import ReservationMixins from '../../../../mixin/tickets'
const {min} = Math
import {alert, getQS} from '../../../../../../lib/utils'
const qs = getQS() || {}
const noHold = !!qs.nohold

export default {
  name: 'timeslot',
  mixins: [ReservationMixins],
  props: {
    time: { default: null },
    disabled: { default: false },
  },
  data() {
    return {
      isProcessing: false,
    }
  },
  created() {

  },
  computed: {
    item() {
      return this.selectedSlots[this.time] || this.retrievedTimeslot(this.time)
    },
    disableSelection() {
      return this.disabled || false
    },
    selected: {
      get() {
        return this.item.selected
      },
      set(value) {
        const item = this.item
        this.setRetrieved(item, 'selected', value)
      }
    }
  },
  methods: {
    setSelected({time}, key, value) {
      this.setTimeslotData({time, key, value})
    },
    setRetrieved({time}, key, value) {
      this.setRetrievedTimeslotData({time, key, value})
    },
    setParticipants(item, value) {
      this.setSelected(item, 'participants', value)
    },
    setHold(item, value) {
      this.setSelected(item, 'hold', value)
    },
    selectTemporary(item) {
      this.selectTimeslot(item)
    },
    deselectTemporary() {
      this.setParticipants(this.item, 0)
    },
    getNumParticipantsToSlot(){
      const quantity = this.totalQuantity || 0
      const remainingToSlot = this.totalParticipantsNotSlotted || 0
      return min(quantity, remainingToSlot) || 0
    },
    async selection() {
      if (this.item.processing) {
        alert('This selected slot is being processed.')
        return false
      }

      const time = this.item.time
      const selected = this.selected = !this.selected
      const now = (new Date()).valueOf()
      const itemToSet = {time, selected: selected ? now : false}

      if (selected) {
        this.unholdFirstSelectedSlot()
      }

      const participants = itemToSet.participants = this.getNumParticipantsToSlot()

      if (!selected) {
        // deselect
        this.deselectTemporary()
        await this.unholdSlot(this.item)

      }  else {
        this.selectTemporary(itemToSet)

        if (participants) {
          const hold = await this.holdSlot(this.item, participants)
          if (hold) {
            hold.participants = participants
            itemToSet.hold = hold
            itemToSet.participants = participants
          } else {
          // unable to hold
            itemToSet.participants = 0
            this.selected = itemToSet.selected = false
          }
        }
      }
      this.updateTimeslotSelection(itemToSet)
    }
  }

}
